import { Controller } from "@hotwired/stimulus"

// Clickable timecodes in the episode description (TimestampLinker): instead of
// leaving for YouTube, scroll to the embedded player and play it from that
// second. Reloading the iframe with start/autoplay needs no YouTube JS API;
// the click is the user gesture that lets autoplay through (allow="autoplay"
// is delegated on the iframe). Modified clicks keep the link's default
// behavior, so cmd-click still opens YouTube in a new tab.
export default class extends Controller {
  static targets = ["player"]

  seek(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey) return

    event.preventDefault()
    const url = new URL(this.playerTarget.src)
    url.searchParams.set("start", event.params.seconds)
    url.searchParams.set("autoplay", "1")
    this.playerTarget.src = url.toString()
    this.playerTarget.scrollIntoView({ behavior: "smooth", block: "center" })
  }
}
